var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.02 134.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{opacity:0.38;}.cls-10,.cls-4,.cls-8,.cls-9{mix-blend-mode:screen;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-13,.cls-7{mix-blend-mode:multiply;}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:#99570e;}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -36.87,
    y1: 1012.05,
    x2: 96.35,
    y2: 1012.05,
    gradientTransform: "translate(46.16 -942.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.31,
    y1: 1053.62,
    x2: 27.31,
    y2: 947.91,
    gradientTransform: "translate(42.74 -941.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 22.64,
    y1: 1025.53,
    x2: 22.64,
    y2: 963.55,
    gradientTransform: "translate(-261.79 -885.67) rotate(-17.79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 43.22,
    y1: 1045.65,
    x2: 43.22,
    y2: 998.74,
    gradientTransform: "translate(-261.79 -885.67) rotate(-17.79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 27.31,
    y1: 945.75,
    x2: 27.31,
    y2: 1059.58,
    gradientTransform: "translate(-261.79 -885.67) rotate(-17.79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 27.31,
    y1: 945.74,
    x2: 27.31,
    y2: 1059.12,
    gradientTransform: "translate(-261.79 -885.67) rotate(-17.79)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -27.66,
    y1: 1000.43,
    x2: 82.27,
    y2: 1000.43,
    gradientTransform: "translate(42.61 -941.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -28.18,
    y1: 1000.43,
    x2: 82.79,
    y2: 1000.43,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 27.31,
    y1: 1033.64,
    x2: 27.31,
    y2: 984.21,
    gradientTransform: "translate(44.82 -942.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff984d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 27.31,
    y1: 1003.41,
    x2: 27.31,
    y2: 977.85,
    gradientTransform: "translate(-261.79 -885.67) rotate(-17.79)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 73.47,
    cy: 69.62,
    rx: 71.14,
    ry: 64.45,
    transform: "translate(-17.76 25.78) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 70.04,
    cy: 58.95,
    rx: 71.14,
    ry: 57.52,
    transform: "translate(-14.66 24.22) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.56,0,2.92,82.45c4.75,13,14.89,23,27.93,29l89.27-98.59C108.84,4.43,93.78-.19,77.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.21,38.63c-.14-.47-.28-.94-.43-1.41A47.25,47.25,0,0,0,131.11,24L47.26,116.61a79,79,0,0,0,19.32,1.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.47,4.19C15.06,16.19-7.4,50.44,2.31,80.69s47.9,45,85.31,33,59.86-46.26,50.16-76.5S89.88-7.82,52.47,4.19Zm35,109C50.42,125,12.63,110.39,3,80.46S15.64,16.64,52.65,4.76s74.81,2.76,84.42,32.68S124.45,101.27,87.44,113.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.47,4.19c-37.41,12-59.9,46.16-50.23,76.29s47.84,44.81,85.24,32.81S147.38,67.13,137.71,37,89.88-7.82,52.47,4.19ZM87.3,112.72C50.28,124.6,12.52,110.06,3,80.25S15.64,16.64,52.65,4.76,127.43,7.42,137,37.23,124.31,100.84,87.3,112.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 69.92,
    cy: 58.56,
    rx: 54.96,
    ry: 44.44,
    transform: "translate(-14.55 24.17) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 69.92,
    cy: 58.56,
    rx: 55.48,
    ry: 44.86,
    transform: "translate(-14.55 24.17) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 70.04,
    cy: 58.95,
    rx: 54.96,
    ry: 44.44,
    transform: "translate(-14.66 24.22) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 72.13,
    cy: 65.44,
    rx: 52.85,
    ry: 36.62,
    transform: "translate(-16.55 25.17) rotate(-17.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M61.7,33c27.22-8.73,54.19-.88,61.1,17.53-.11-.4-.22-.8-.35-1.2C116.27,30,88.73,21.66,60.94,30.58s-45.31,31.76-39.13,51c.12.4.26.79.41,1.18C17.13,63.78,34.49,41.69,61.7,33Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/coin3.412d5a8dc5bf7581c7fd3af1851e3159.svg";
export { ForwardRef as ReactComponent };